import { Chart } from '@frontend/chart/types';

export const FILL_RATE_TOTAL_METRIC_CHART_MOCK_DATA: Chart = {
    series: [{ name: 'Fill rate', data: [{ label: 'full_period', value: 87 }] }]
};
